var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.5C13.93 3.5 14.395 3.5 14.7765 3.60222C15.8117 3.87962 16.6204 4.68827 16.8978 5.72354C17 6.10504 17 6.57003 17 7.5V16.7C17 18.3802 17 19.2202 16.673 19.862C16.3854 20.4265 15.9265 20.8854 15.362 21.173C14.7202 21.5 13.8802 21.5 12.2 21.5H5.8C4.11984 21.5 3.27976 21.5 2.63803 21.173C2.07354 20.8854 1.6146 20.4265 1.32698 19.862C1 19.2202 1 18.3802 1 16.7V7.5C1 6.57003 1 6.10504 1.10222 5.72354C1.37962 4.68827 2.18827 3.87962 3.22354 3.60222C3.60504 3.5 4.07003 3.5 5 3.5M6 14.5L8 16.5L12.5 12M6.6 5.5H11.4C11.9601 5.5 12.2401 5.5 12.454 5.39101C12.6422 5.29513 12.7951 5.14215 12.891 4.95399C13 4.74008 13 4.46005 13 3.9V3.1C13 2.53995 13 2.25992 12.891 2.04601C12.7951 1.85785 12.6422 1.70487 12.454 1.60899C12.2401 1.5 11.9601 1.5 11.4 1.5H6.6C6.03995 1.5 5.75992 1.5 5.54601 1.60899C5.35785 1.70487 5.20487 1.85785 5.10899 2.04601C5 2.25992 5 2.53995 5 3.1V3.9C5 4.46005 5 4.74008 5.10899 4.95399C5.20487 5.14215 5.35785 5.29513 5.54601 5.39101C5.75992 5.5 6.03995 5.5 6.6 5.5Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.38f2acfb087e79ddd2d2efa2fa4143a0.svg";
export { ForwardRef as ReactComponent };